import React from "react";
import { useState } from "react";
import ApplicationModal from "./AddApplicationModal";
import ExportReportsOffcanvas from "./ExportReportsOffcanvas";
import { useAuth } from "../contexts/AuthContext";
import fallBackImage from '../Assests/images/placeholderimage.jpg'
import ApplicationProgressOffCanvas from "./ApplicationProgressOffCanvas";
import { DocumentChartBarIcon } from "@heroicons/react/20/solid";

export default function ApplicationCard({
    userRole,
    applicationDetail,
    getApplicationDetail,
    handleExport,
    permission
}) {
    const { user } = useAuth();
    const [selectedApp, setSelectedApp] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [modelType, setModelType] = useState('')
    const [isExportModalOpen, setIsExportModalOpen] = useState(false);
    const [openOffCanvas, setOpenOffCanvas] = useState(false)
    const isAdmin = userRole?.role_name === 'Admin';


    const handleDownload = async (file) => {
        if (!file) return;

        try {
            const API_BASE_URL = "http://130.131.36.136:8000";
            const url = file.startsWith("http") ? file : `${API_BASE_URL}${file}`;

            const response = await fetch(url, { mode: "cors" });
            if (!response.ok) throw new Error("Failed to fetch file");

            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);

            const filename = url.split("/").pop() || "attachment";
            const ext = filename.split(".").pop().toLowerCase();

            // Create temporary download link
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // ✅ Only open in new tab for PDFs
            if (ext === "pdf") {
                window.open(blobUrl, "_blank", "noopener,noreferrer");
            }

            // Cleanup
            setTimeout(() => URL.revokeObjectURL(blobUrl), 2000);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };




    return (
        <>

            <div className="flex items-start justify-between bg-white shadow-md rounded-xl p-5 mb-4">
                {/* Left Section */}
                <div className="flex items-center gap-5">
                    {/* Icon */}
                    <div className="w-[145px] h-[145px] flex items-center justify-center bg-blue-50 rounded-lg">
                        {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="#2563eb"
                            className="w-10 h-10"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M3.75 5.25h16.5M3.75 12h16.5M3.75 18.75h16.5"
                            />
                        </svg> */}
                        <img src={applicationDetail?.icon || fallBackImage} alt={applicationDetail?.name} className="w-10 h-10 rounded-lg object-cover"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = fallBackImage;
                            }}
                        />
                    </div>

                    {/* Content */}
                    <div>
                        <h2 className="text-[20px] font-semibold">{applicationDetail?.name}</h2>

                        {/* Tags */}
                        <div className="flex gap-2 my-2">
                            <span className="bg-orange-100 text-orange-600 text-xs px-4 py-2 rounded-md font-semibold">
                                {applicationDetail?.subject_name}
                            </span>
                            <span className="bg-gray-100 text-gray-600 text-xs px-4 py-2 rounded-md font-semibold">
                                {applicationDetail?.grade_name}
                            </span>
                            {applicationDetail?.is_active == 1 ?
                                <span className="border border-green-500 text-green-600 text-xs px-4 py-2 rounded-md flex items-center gap-1 font-semibold">
                                    <span className="w-2 h-2 rounded-full bg-green-500"></span>
                                    Active
                                </span>
                                : <span className="border border-red-500 text-red-600 text-xs px-4 py-2 rounded-md flex items-center gap-1 font-semibold">
                                    <span className="w-2 h-2 rounded-full bg-red-500"></span>
                                    In-active
                                </span>
                            }
                        </div>

                        {/* Details */}
                        <div className="flex flex-col sm:flex-row sm:gap-8 text-sm my-4 ">

                            <div>
                                <span className="font-semibold text-[#283C50]">Location: </span>   <p className="text-gray-600 py-2">

                                    {applicationDetail?.location}
                                </p>
                            </div>
                            <div>
                                <span className="font-semibold  text-[#283C50" >Launch Date: </span>
                                <p className="text-gray-600 py-2">

                                    {applicationDetail?.launch_date}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Section: Actions */}
                <div className="flex gap-2">
                    {/* Only show Edit and Export actions for Admin */}
                    {(permission?.downloadAttachment === true && applicationDetail?.attachment_link) &&
                        <button
                            className="bg-[#283C50] text-white px-5 py-2 rounded-lg text-sm hover:bg-[#283c50b0]"
                            onClick={() => handleDownload(applicationDetail?.attachment_link)}
                        >
                            Download Attachment
                        </button>
                    }
                    {permission?.updateApplicationProgress === true &&
                        <button
                            onClick={() => setOpenOffCanvas(true)}
                            className="border flex gap-2 border-blue-500 text-blue-500 px-4 py-2 rounded-lg text-sm hover:bg-blue-50"
                        >
                            <DocumentChartBarIcon
                                className="w-5 h-5 cursor-pointer text-grey-600 hover:font-800" />
                            App Progress
                        </button>
                    }
                    {permission?.edit === true &&
                        <button
                            onClick={() => {
                                setSelectedApp(applicationDetail);
                                setModelType('Edit')
                                setModalOpen(true);
                            }}
                            className="bg-[#283C50] text-white px-5 py-2 rounded-lg text-sm hover:bg-[#283c50b0]"
                        >
                            Edit Application
                        </button>
                    }

                    {permission?.export === true &&
                        <button
                            onClick={handleExport}
                            className="bg-brandBlue text-white px-3 flex gap-2 py-2 rounded-lg hover:bg-brandBlue-600 transition">
                            <span><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21 3H3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4V20C2 20.2652 2.10536 20.5196 2.29289 20.7071C2.48043 20.8946 2.73478 21 3 21H21C21.2652 21 21.5196 20.8946 21.7071 20.7071C21.8946 20.5196 22 20.2652 22 20V4C22 3.73478 21.8946 3.48043 21.7071 3.29289C21.5196 3.10536 21.2652 3 21 3ZM12 16C11.2044 16 10.4413 15.6839 9.87868 15.1213C9.31607 14.5587 9 13.7956 9 13H4V5H20V13H15C15 13.7956 14.6839 14.5587 14.1213 15.1213C13.5587 15.6839 12.7956 16 12 16ZM16 11H13V14H11V11H8L12 6.5L16 11Z" fill="white" />
                            </svg>
                            </span> Export  </button>
                    }
                </div>
            </div>
            {/* Only show modals for Admin */}
            {permission?.edit === true &&
                <ApplicationModal
                    isOpen={modalOpen}
                    onClose={setModalOpen}
                    type={modelType}
                    selectedApp={selectedApp}
                    setSelectedApp={setSelectedApp}
                    setModelType={setModelType}
                    getAllApplicationList={() => { getApplicationDetail() }}
                />
            }

            <ExportReportsOffcanvas
                isExportModalOpen={isExportModalOpen}
                onClose={() => setIsExportModalOpen(false)}
            />
            {permission?.updateApplicationProgress === true &&
                <ApplicationProgressOffCanvas openOffCanvas={openOffCanvas} setOpenOffCanvas={setOpenOffCanvas} />
            }





        </>
    );
}
